import {createQueryKeys} from "../../shared/query/query-keys";

export const materialFunctionKeys = createQueryKeys("materialFunctions");

export const materialFunctionMutationKeys = {
  createMaterialFunction: ["materialFunctions", "mutation", "create-material-function"] as const,
  updateMaterialFunction: ["materialFunctions", "mutation", "update-material-function"] as const,
  deleteMaterialFunction: ["materialFunctions", "mutation", "delete-material-function"] as const,
  restoreMaterialFunction: ["materialFunctions", "mutation", "restore-material-function"] as const,
} as const;
